










































import Vue from 'vue';

import List from '@/models/soukai/List';

export default Vue.extend({
    methods: {
        editList(list: List) {
            this.$ui.openDialog(
                () => import('@/dialogs/ListForm.vue'),
                { list },
            );
        },
    },
});
